export const SNAPSHOT_DEFAULT_FORMAT: string = "png";
